import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.auth/change-password/change-password-fieldset.htm";

export class ChangePasswordFieldsetController {
  constructor() {
    basicController(this);
    let $ctrl = this;
    $ctrl.bus = $ctrl.$session.bus;
  }
}

export default {
  bindings: {
    request: "<"
  },
  templateUrl
};
